import React from 'react';
import PropTypes from 'prop-types';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';

import { CustomButton } from './styles';
import theme from '../../styles/theme';

function Button({
  primary,
  secondary,
  color,
  children,
  onClick,
  isLoading,
  blackText,
}) {
  return (
    <CustomButton
      type="submit"
      primary={primary}
      secondary={secondary}
      color={color}
      onClick={onClick}
      isLoading={isLoading}
      disabled={isLoading}
      blackText={blackText}
    >
      {isLoading ? (
        <Loader
          type="ThreeDots"
          color={theme.accent}
          height={24}
          width={24}
          timeout={7000}
        />
      ) : (
        children
      )}
    </CustomButton>
  );
}

Button.propTypes = {
  color: PropTypes.string,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  blackText: PropTypes.bool,
};

Button.defaultProps = {
  color: '',
  primary: false,
  secondary: false,
  onClick: null,
  isLoading: false,
  blackText: false,
};

export default Button;
